import { render } from "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=template&id=b7d2627a&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=style&index=0&id=b7d2627a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d2627a"]])

export default __exports__